export default __webpack_public_path__ + "static/media/blocknet.f996892c.png";